module.exports = __webpack_public_path__ + "img/ztpx_banner.e2651f59.png";